import {
  Service
} from '../../../service.js';
import {
  env
} from '../../../env.js';
import {
  toastUtils
} from '../../../util/toast.utils.js';

class CadastroTarefasService extends Service {

  constructor() {
    super()

    this.url = env.url + 'tarefas'
  }

  async buscarTarefa(id) {
    return super.get(this.url + `/${id}`)
  }

  async listarTarefa(objetoDeFiltros, removerPagina = false) {
    if(removerPagina) {
      delete objetoDeFiltros.pagina;
    }
    const queryString = this.converterObjetoDeFiltrosParaURIEncodedString(objetoDeFiltros);
    return super.get(this.url + queryString);
  }

  getDepartamentoQueryString(departamentoId) {
    var parametro = "departamentoId";

    if (departamentoId.includes("P")) {
      parametro = "departamentoPadrao";
      departamentoId = departamentoId.replace("P", "");
    }

    return `&${parametro}=${departamentoId}`;
  }

  //TODO: Implementar services segragados na ECT-79;
  //services de departamentos e departamentos padrão foram segredados e
  //foi criado um útil para retornar os dois concatenados no formato utilizado
  //pelo front;
  async listarDepartamentos() {
    var url = `${env.baseDocumento}departamentos-do-bureau?page[offset]=0`;
    return super.buscarEconverterObjeto(url);
  }

  async listarDepartamentosPadroes() {
    var url = `${env.url}departamento-padrao`;
    var departamentosPadroes = await super.get(url);

    return departamentosPadroes.map((departamento) => {
      return {
        value: 'P' + departamento.id,
        label: departamento.nome
      };
    });
  }

  async listarRecorrencias() {
    const recorrencias_data = await super.get(`${env.url}recorrencias`);

    return recorrencias_data;

  }

  async listarCompetencias(id) {
    const competencias_data = await super.get(`${env.url}recorrencias/${id}`);
    return competencias_data.competencias.map((element) => {
      return {
        value: element.id,
        label: element.descricao
      };
    })
  }

  async listarTiposPrazosEntrega() {
    const tipos_prazos_de_entrega_data = await super.get(`${env.url}tipos-prazo-entrega`);
    return tipos_prazos_de_entrega_data.map((element) => {
      return {
        value: element.id,
        label: element.descricao
      };
    })
  }

  async listarResponsaveis() {
    const responsaveis = await super.get(`${env.url}usuarios?tipo=1&status=1&usuarioAgenteIA=false`);
    const total = responsaveis.totalDeItens
    const responsaveis_data = await super.get(`${env.url}usuarios?tipo=1&status=1&limit=${total}&usuarioAgenteIA=false`)
    return responsaveis_data.data.map((element) => {
      return {
        value: element.id,
        label: element.nome
      };
    })
  }

  async listarTodasAsTarefasPadrao() {
    const objetoDeFiltros = {
      "padrao": true,
      limit: 1,
      pagina: 1
    } 
    let queryString = this.converterObjetoDeFiltrosParaURIEncodedString(objetoDeFiltros);
    const padrao = await super.get(this.url + queryString);
    const total = padrao.totalDeItens;

    objetoDeFiltros.limit = total;
    queryString = this.converterObjetoDeFiltrosParaURIEncodedString(objetoDeFiltros);

    const tarefasPadraoData = await super.get(this.url + queryString);
    return tarefasPadraoData;
  }

  async delete(item) {

    return await super.delete(this.url, item)
  }

  async post(item,temPermissaoParaEmpresasEDepartamentos) {

    if (item.departamentoId.includes("P")) {
      item.departamentoPadraoId = item.departamentoId.replace("P", "");
      item.departamentoId = "";
    }

    const response = await super.post(this.url, item)
    const responseJson = await response.json();
    if (response.status === 201) {
      toastUtils.successToast("Tarefa cadastrada com sucesso!");
      if(responseJson.tarefaCliente) {
        toastUtils.alertToast("Uma notificação referente a esta tarefa será enviada para o cliente.");
      }
      if (temPermissaoParaEmpresasEDepartamentos) {
        setTimeout(() => {
          window.location.reload(true)
          }, 3000);
      } else {
        return response;
      }
    } else {
      throw new Error('HTTP ' + response.status)
    }

  }

  async editarTarefa(dto) {

    if (dto.departamentoId.includes("P")) {
      dto.departamentoPadraoId = dto.departamentoId.replace("P", "");
      dto.departamentoId = "";
    }

    const response = await super.patch(this.url, dto)
    if (response.status === 200) {
      toastUtils.successToast("Tarefa editada com sucesso!");
      setTimeout(() => {
        window.location.reload(true)
      }, 3000);

    } else {
      throw new Error('HTTP ' + response.status)
    }
  }

  async edicaoEmLote(dto) {
    return await super.post(`${this.url}/edicao-lote`, dto);
  }
}

export const service = new CadastroTarefasService()
